import { render, staticRenderFns } from "./InstallationInstarctionPage.vue?vue&type=template&id=515ca5d9&scoped=true"
import script from "./InstallationInstarctionPage.vue?vue&type=script&lang=js"
export * from "./InstallationInstarctionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515ca5d9",
  null
  
)

export default component.exports